module.exports = __webpack_public_path__ + "static/media/Integracion Afap.1873ab0b.svg";